import UiButton from './UiButton.vue';
import UiPagination from './UiPagination.vue';
import UiPopup from './UiPopup.vue';
import UiTable from './UiTable.vue';
import UiColumnsSelect from './UiColumnsSelect.vue';


export default {
  install(Vue, options) {
    Vue.component(UiButton.name, UiButton);
    Vue.component(UiPagination.name, UiPagination);
    Vue.component(UiPopup.name, UiPopup);
    Vue.component(UiTable.name, UiTable);
    Vue.component(UiColumnsSelect.name, UiColumnsSelect);
  },
};
